import { render, staticRenderFns } from "./MagazzinoArticoliStoricoMovimentazioneContabilitaComponent.vue?vue&type=template&id=b89eee38&scoped=true"
import script from "./MagazzinoArticoliStoricoMovimentazioneContabilitaComponent.vue?vue&type=script&lang=js"
export * from "./MagazzinoArticoliStoricoMovimentazioneContabilitaComponent.vue?vue&type=script&lang=js"
import style0 from "./MagazzinoArticoliStoricoMovimentazioneContabilitaComponent.vue?vue&type=style&index=0&id=b89eee38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89eee38",
  null
  
)

export default component.exports